import { cva, type VariantProps } from "class-variance-authority";
import type { ButtonHTMLAttributes } from "react";
import { cn } from "@/lib/utils";
export const buttonVariants = cva("ui-button avm-btn", {
  variants: {
    variant: { default:"avm-btn--primary", primary:"avm-btn--primary", secondary:"avm-btn--secondary", outline:"avm-btn--secondary", ghost:"avm-btn--tertiary", tertiary:"avm-btn--tertiary", destructive:"avm-btn--danger-subtle", danger:"avm-btn--danger", "danger-subtle":"avm-btn--danger-subtle" },
    size: { default:"", sm:"avm-btn--sm", lg:"avm-btn--lg" },
  }, defaultVariants:{variant:"default",size:"default"},
});
export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof buttonVariants> {}
export function Button({className,variant,size,...props}:ButtonProps) { return <button className={cn(buttonVariants({variant,size}),className)} {...props}/>; }
